import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class TransferMultiplesDocumentToOtherCompany {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend
  ) { }

  async run(ids:[Number]): Promise<any> {
    let args = { 
      ids: ids
    }
    try{
      await this.dispatcher.dispatch('perform.transfer.to.right.company.multiple', args)
    } catch(error) {
      console.error('Error during transfer documents to right company', error)
    }
    this.frontend.refreshData();
    this.frontend.loadingAction = false;
  }
}